import LegalPage from '@/components/LegalPage';

const copyrightContent = `# SeekScape — Copyright Notice

**Effective Date:** April 6, 2026

## Copyright Ownership

© 2026 SeekScape. All rights reserved.

## Protected Content

The following elements of the SeekScape application are protected by copyright law:

- **Wallpapers and Digital Art:** All wallpapers available through SeekScape are original works or licensed content, protected under applicable copyright laws. Each wallpaper is the intellectual property of its respective creator.
- **Application Design:** The user interface, layout, visual design, animations, and overall look and feel of the SeekScape application.
- **Branding:** The SeekScape name, logo, and associated branding elements are proprietary.
- **Software Code:** All source code, algorithms, and technical implementations powering the SeekScape platform.

## Creator Rights

Wallpaper creators who submit content to SeekScape retain ownership of their original works. By publishing on SeekScape, creators grant SeekScape a non-exclusive license to display, distribute, and sell their wallpapers through the platform.

## User Rights

Users who purchase wallpapers receive a personal-use license as outlined in the SeekScape License Agreement. Purchase does not constitute transfer of copyright.

## DMCA / Takedown Policy

SeekScape respects the intellectual property rights of others. If you believe your copyrighted work has been used without authorization, please contact us with:

1. A description of the copyrighted work
2. The location of the allegedly infringing content within the App
3. Your contact information
4. A statement of good faith belief that the use is unauthorized
5. A statement, under penalty of perjury, that the information provided is accurate

## Enforcement

Unauthorized reproduction, distribution, display, or creation of derivative works from SeekScape content may result in civil and criminal penalties under copyright law.

## Contact

For copyright inquiries or takedown requests, please reach out through the SeekScape application.`;

export default function CopyrightPage() {
  return <LegalPage title='Copyright Notice' content={copyrightContent} />;
}
